import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { formatCurrency, formatDate } from '../../common/helpers'

// Components
import withDataTable from '../../app/components/dataTable/withDataTable'
import DataTable from '../../app/components/dataTable'
import { StyledSpan } from '../../theme/Global'

const StateWageDetailTableRenderer = ({
  columns,
  defaultSort,
  onExport,
  onFilter,
  onSort,
  recordCount,
  recordType,
  renderRow
}) => (
  <React.Fragment>
    <DataTable
      defaultSort={defaultSort}
      columns={columns}
      data={renderRow}
      onExport={onExport}
      onFilter={onFilter}
      onSort={onSort}
      recordType={recordType}
      recordCount={recordCount}
      perPage={9999}
      showControls={false}
    />
  </React.Fragment>
)

const mapStateToProps = (state, ownProps) => ({})

const StateWageDetailTableComponent = compose(
  connect(mapStateToProps),
  withDataTable({
    filters: [],
    renderItem: (item) => ({
      wage: <StyledSpan>{ formatCurrency(item.wage, 'TBD') }</StyledSpan>,
      jurisdictionName: <StyledSpan>{ item.jurisdictionName }</StyledSpan>,
      effectiveDate: <StyledSpan>{ formatDate(item.effectiveDate) }</StyledSpan>,
      expireDate: <StyledSpan>{ formatDate(item.expireDate) }</StyledSpan>
    })
  })
)(StateWageDetailTableRenderer)

export default StateWageDetailTableComponent
